import React from 'react';

import type { TextBlock } from '@/types/pageContentTypes';
import RichText from '@/components/ui/RichText/RichText';

interface FormSectionProps {
  heading?: TextBlock;
  description?: TextBlock;
  form: React.ReactNode;

  id?: string;
  className?: string;
  contentClassName?: string;
  wrapperClassName?: string;

  hideIntro?: boolean;
  formSurface?: 'card' | 'plain';
  align?: 'center' | 'start';
}

export default function FormSection({
  heading,
  description,
  form,
  id,
  className = '',
  contentClassName = 'p-8',
  wrapperClassName = '',
  hideIntro = false,
  formSurface = 'card',
  align = 'center',
}: FormSectionProps): React.ReactElement {
  return (
    <section
      id={id}
      className={`w-full bg-gray-100 py-8 md:py-10 ${className}`}
    >
      <div
        className={`content-wrapper grid grid-cols-1 gap-8 ${
          align === 'start' ? 'items-start' : 'items-center'
        } ${hideIntro ? 'md:grid-cols-1' : 'md:grid-cols-7'} ${wrapperClassName}`}
      >
        {!hideIntro && heading && (
          <div className="flex flex-col items-start justify-center gap-4 md:col-span-3">
            <RichText
              styles={
                heading.styles ?? {
                  p: 'font-bold text-theme-primary text-h2',
                  h2: 'font-bold text-theme-primary text-h2',
                }
              }
            >
              {heading.content}
            </RichText>

            {description && (
              <RichText styles={description.styles}>
                {description.content}
              </RichText>
            )}
          </div>
        )}

        <div
          className={`flex flex-col gap-6 ${
            hideIntro ? 'mx-auto w-full max-w-[720px]' : 'md:col-span-4'
          } ${
            formSurface === 'card' ? 'rounded-2xl bg-white shadow-sm' : ''
          } ${contentClassName}`}
        >
          {form}
        </div>
      </div>
    </section>
  );
}
